import { publicHref } from '../lib/publicUrls';
import { Link } from 'react-router-dom';
import { Phone, Calendar, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Premium in-article CTA block that nudges readers toward booking a tour or membership.
 * Place it before the FAQ section on every blog post.
 */
const ArticleCTABox = () => {
  return (
    <div
      className="my-12 relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#0072BB] via-[#0091D5] to-[#005A94] p-8 md:p-10 text-white shadow-xl"
      data-testid="article-cta-box"
    >
      {/* Decorative noise/gradient */}
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-20 mix-blend-overlay pointer-events-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E\")",
        }}
      />
      <div className="relative grid md:grid-cols-3 gap-6 items-center">
        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-widest text-blue-100/90 mb-2 font-semibold">
            Ready to get started?
          </div>
          <h3 className="dv-size-subheading text-2xl md:text-3xl font-bold mb-3 leading-tight">
            See Delta Valley for yourself — book a club tour.
          </h3>
          <p className="dv-size-lede text-blue-50/90 text-base md:text-lg leading-relaxed">
            Two locations in Brentwood &amp; Discovery Bay. 50+ weekly classes, indoor pool, reformer Pilates,
            MX4, pickleball, and kid&rsquo;s club. Membership options start at $75/month.
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <Link to={publicHref("/contact")} className="block">
            <Button
              size="lg"
              className="w-full bg-white text-[#0072BB] hover:bg-blue-50 font-bold shadow-md"
              data-testid="cta-book-tour"
            >
              <Calendar size={18} className="mr-2" />
              Book a Tour
              <ArrowRight size={18} className="ml-2" />
            </Button>
          </Link>
          <a href="tel:+19252402990" className="block">
            <Button
              size="lg"
              variant="outline"
              className="w-full bg-transparent border-white/60 text-white hover:bg-white/10 hover:text-white"
              data-testid="cta-call-now"
            >
              <Phone size={18} className="mr-2" />
              (925) 240-2990
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ArticleCTABox;
